<template>
  <section class="testimonials-section">
    <v-container style="max-width: 1200px">
      <div class="text-center mb-12">
        <p class="section-eyebrow">{{ $t('testimonials.eyebrow') }}</p>
        <h2 class="section-title">{{ $t('testimonials.title') }}</h2>
      </div>

      <v-row>
        <v-col
          v-for="(t, i) in testimonials"
          :key="i"
          cols="12"
          md="4"
        >
          <div class="testimonial-card">
            <div class="stars mb-4">
              <v-icon v-for="n in 5" :key="n" small color="secondary">mdi-star</v-icon>
            </div>
            <p class="quote mb-6">"{{ t.quote }}"</p>
            <div class="d-flex align-center">
              <div class="avatar mr-3" :style="{ background: avatarColors[i] }">
                {{ t.name.split(' ').map(w => w[0]).join('') }}
              </div>
              <div>
                <p class="author-name">{{ t.name }}</p>
                <p class="author-detail">{{ t.detail }}</p>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'Testimonials',
  data() {
    return {
      avatarColors: ['#4257b2', '#7b1fa2', '#0097a7'],
    }
  },
  computed: {
    testimonials() {
      return this.$t('testimonials.items')
    },
  },
}
</script>

<style scoped>
.testimonials-section {
  padding: 96px 16px;
  background: white;
}

.section-eyebrow {
  font-size: 0.8rem;
  font-weight: 700;
  color: #F77317;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  margin-bottom: 12px;
}

.section-title {
  font-size: 2.4rem;
  font-weight: 900;
  color: #4055AF;
  letter-spacing: -1px;
  line-height: 1.15;
  margin: 0;
}

.testimonial-card {
  background: #f8f9fc;
  border: 1px solid #ebebeb;
  border-radius: 20px;
  padding: 32px 28px;
  height: 100%;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.testimonial-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 32px rgba(0, 0, 0, 0.06);
}

.quote {
  font-size: 0.95rem;
  color: #444;
  line-height: 1.8;
  margin: 0;
  font-style: italic;
}

.avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.author-name {
  font-size: 0.9rem;
  font-weight: 700;
  color: #4055AF;
  margin: 0;
}

.author-detail {
  font-size: 0.8rem;
  color: #999;
  margin: 2px 0 0;
}
</style>
